import React from "react";
import AdBanner from "./AdBanner";

const Features = () => {
  return (
    <section>
      <h2>Öne Çıkan Özellikler</h2>
      <div className="feature-gallery">
        <img src="/show.JPG" alt="Uygulama Gösterimi" />
      </div>
      
      {/* Advertisement */}
      <AdBanner
        imageSrc="/ad_celenk_gayrimenkul.JPG"
        altText="Çelenk Gayrimenkul Reklamı"
        companyName="Çelenk Gayrimenkul - Emlak Hizmetleri"
        link="#"
        className="horizontal"
      />
      
      <ul>
        <li>Harita üzerinden otopark gösterimi</li>
        <li>Boş/dolu otopark bilgisi</li>
        <li>QR kod ile giriş-çıkış</li>
        <li>Abonelik ve dijital ödeme</li>
        <li>Reklam alanları ile gelir desteği</li>
        <li>Kullanıcı dostu sade arayüz</li>
        <li>Telefon, tablet ve bilgisayarlarla tam uyumlu yapı</li>
        <li>Kurumlar için yönetim paneli</li>
      </ul>
    </section>
  );
};

export default Features;
